import { render } from "./PartnersCards.vue?vue&type=template&id=372aa490"
import script from "./PartnersCards.vue?vue&type=script&lang=js"
export * from "./PartnersCards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__